import React from "react";
import styles from './ClinicalSiteCard.module.scss';
import PropTypes from "prop-types";
import Icon from "../icon/Icon";
import Tag from "../tag/Tag";
import Button from "../button/Button";

const ClinicalSiteCard = ({
  name,
  address,
  detailItems,
  status = 'Active',
  onClick,
  type = 'clinic',
  actions
}) => {

  const getStatusVariant = (statusText) => {
    switch(statusText) {
      case 'Active': return 5;
      case 'Up to Date': return 5;
      case 'Inactive': return 6;
      case 'Expired': return 6;
      default: return 3;
    }
  };

  const iconName = (type === 'clinic' || type === 'health-system') ? 'clinic-full' : 'file-text';

  const handleCardClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={`${styles.card} ${(type === 'clinic' || type === 'health-system') ? styles.clickable : ''}`} onClick={handleCardClick}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <div className={`${styles.icon} ${styles[type]}`}>
             <Icon name={iconName} /> 
          </div>
          <div className={styles.info}>
            <h3>{name}</h3>
            <p>{address}</p>
          </div>
        </div>
        <div className={styles.status}>
          <Tag text={status} variant={getStatusVariant(status)} rounded={true} />
        </div>
      </div>

      <div className={styles.details}>
        {detailItems.map((item, index) => (
          <div className={styles.detailItem} key={index}>
            <label>{item.label}</label>
            <span>{item.value}</span>
          </div>
        ))}
      </div>

      {actions && actions.length > 0 && (
        <div className={styles.actions}>
           {actions.map((action, index) => (
             <Button 
               key={index}
               {...action}
               size="small" // Enforce small size for card actions or allow override
               onClick={(e) => {
                 e.stopPropagation();
                 if (action.onClick) action.onClick(e);
               }}
             />
           ))}
        </div>
      )}
    </div>
  );
};

ClinicalSiteCard.propTypes = {
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  status: PropTypes.string,
  detailItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['clinic', 'document', 'health-system']),
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    variant: PropTypes.string,
    disabled: PropTypes.bool
  }))
};

export default ClinicalSiteCard;
